import React from 'react';

import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { signUp } from '../thunk';

import type { SignUpInput } from '@/infra/cognitoIApi';

import TextFieldComp from '@/components/TextFieldComp';
import { userSlice } from '@/domain/user/redux';
import { Address } from '@/domain/user/service/entity/valueObjects/address';
import { Email } from '@/domain/user/service/entity/valueObjects/email';
import { FamilyName } from '@/domain/user/service/entity/valueObjects/familyName';
import { FamilyNameKana } from '@/domain/user/service/entity/valueObjects/familyNameKana';
import { Name } from '@/domain/user/service/entity/valueObjects/name';
import { NameKana } from '@/domain/user/service/entity/valueObjects/nameKana';
import { Password } from '@/domain/user/service/entity/valueObjects/password';
import { PostalCode } from '@/domain/user/service/entity/valueObjects/postalCode';
import { Tel } from '@/domain/user/service/entity/valueObjects/tel';
import { UserId } from '@/domain/user/service/entity/valueObjects/userId';

const SignUp: React.FC = () => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
    getValues,
  } = useForm<SignUpInput>({
    defaultValues: {
      userId: '',
      password: '',
      passwordConfirm: '',
      email: '',
      name: '',
      nameKana: '',
      familyName: '',
      familyNameKana: '',
      address: '',
      postalCode: '',
      tel: '',
    },
  });
  const onSubmit = (input: SignUpInput) => {
    dispatch(signUp(input));
  };
  return (
    <div>
      <h2 style={{ textAlign: 'center' }}>
        新規ユーザー登録
      </h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3>
          基本情報
        </h3>
        <TextFieldComp
          type={UserId.type}
          control={control}
          rules={UserId.validationRule}
          name={UserId.key}
          label={UserId.label}
          placeholder={UserId.placeholder}
          errors={errors}
        />
        <TextFieldComp
          type={Password.type}
          control={control}
          rules={Password.validationRule}
          name={Password.key}
          label={Password.label2}
          placeholder=""
          errors={errors}
        />
        <TextFieldComp
          type={Password.type}
          control={control}
          rules={{
            ...Password.validationRule,
            validate: (value: string) => {
              const result = getValues().password !== value;
              if (result) {
                return 'パスワードが一致しません';
              }
              return null;
            },
          }}
          name="passwordConfirm"
          label={`${Password.label} (確認)`}
          placeholder=""
          errors={errors}
        />
        <div style={{ display: 'grid', gap: '0 5px', gridTemplateColumns: '1fr 1fr' }}>
          <TextFieldComp
            type={FamilyName.type}
            control={control}
            rules={FamilyName.validationRule}
            name={FamilyName.key}
            label={FamilyName.label}
            placeholder={FamilyName.placeholder}
            errors={errors}
          />
          <TextFieldComp
            type={Name.type}
            control={control}
            rules={Name.validationRule}
            name={Name.key}
            label={Name.label}
            placeholder={Name.placeholder}
            errors={errors}
          />
          <TextFieldComp
            type={FamilyNameKana.type}
            control={control}
            rules={FamilyNameKana.validationRule}
            name={FamilyNameKana.key}
            label={FamilyNameKana.label}
            placeholder={FamilyNameKana.placeholder}
            errors={errors}
          />
          <TextFieldComp
            type={NameKana.type}
            control={control}
            rules={NameKana.validationRule}
            name={NameKana.key}
            label={NameKana.label}
            placeholder={NameKana.placeholder}
            errors={errors}
          />
        </div>
        <TextFieldComp
          type={Email.type}
          control={control}
          rules={Email.validationRule}
          name={Email.key}
          label={Email.label}
          placeholder={Email.placeholder}
          errors={errors}
        />
        <TextFieldComp
          type={Tel.type}
          control={control}
          rules={Tel.validationRule}
          name={Tel.key}
          label={Tel.label}
          placeholder={Tel.placeholder}
          errors={errors}
        />
        <h3>
          住所
        </h3>
        <TextFieldComp
          type={PostalCode.type}
          control={control}
          rules={PostalCode.validationRule}
          name={PostalCode.key}
          label={PostalCode.label}
          placeholder={PostalCode.placeholder}
          errors={errors}
        />
        <TextFieldComp
          type={Address.type}
          control={control}
          rules={Address.validationRule}
          name={Address.key}
          label={Address.label}
          placeholder={Address.placeholder}
          errors={errors}
        />
        <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
          ユーザーIDとパスワードを入力して新規登録ボタンを押してください。
        </div>
        <div style={{ textAlign: 'center', margin: '10px 0' }}>
          <Button
            size="large"
            type="submit"
            variant="contained"
            color="primary"
          >
            新規登録
          </Button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button size="small" onClick={() => dispatch(userSlice.actions.setMode('signin'))}>
            ログイン画面へ
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
